<template>
    <div>
        <div class="input-inline line-item">
            <div class="column">
                <div class="input-inline">
                    <label for="" class="line-number">
                        Line No. <span class="required">*</span>
                        <input type="text" name="lineNumber" id="lineNumber" v-model="item.lineNumber">
                    </label>
                    <label for="">
                        Item Number <span class="required">*</span>
                        <input type="text" name="itemNumber" id="itemNumber" v-model="item.itemNumber">
                    </label>
                    <!-- display for Overage -->
                    <label for="quantityReceived" v-if="displayReceived">
                        Qty. Received <span class="required">*</span>
                        <input type="text" name="quantityReceived" id="quantityReceived" v-model="item.quantityReceived" required>
                    </label>
                    <!-- display for Material Return, Shortage, Wrong Item Shipped  -->
                    <label for="quantityReturning" v-if="displayReturning" v-cloak>
                        <span v-text="returnLabelText"></span>  <span class="required" v-if="returnQtyRequired">*</span>
                        <input type="text" name="quantityReturning" id="quantityReturning" v-model="item.quantityReturning">
                    </label>
                    <!-- display for Pricing -->
                    <label for="priceBilled" v-if="displayPricing">
                        Price Billed <span class="required">*</span>
                        <input type="text" name="priceBilled" id="priceBilled" v-model="item.priceBilled" required>
                    </label>
                    <label for="poPrice" v-if="displayPricing">
                        PO Price <span class="required">*</span>
                        <input type="text" name="poPrice" id="poPrice" v-model="item.poPrice" required>
                    </label>
                </div>
                <!-- display for Wrong Item Shipped -->
                <div class="input-inline">
                    <label for="itemRecieved" v-if="displayItemReceived" class="item-received" v-cloak>
                         Item Received <span class="required">*</span>
                        <input type="text" id="itemReceived" v-model="item.itemReceived" required>
                        <div class="help">(advise if keeping)</div>
                    </label>
                </div>
            </div>

            <div class="column icon">
                <i @click="removeLineItem" class="fa fa-trash"></i>
            </div>
        </div>
                
    </div>
</template>

<script>
    export default {
        data() {
            return {}
        },
        computed: {
        },
        methods: {
            updateLineItem() {
                this.$emit('update-line-item', this.item);
            },
            removeLineItem()  {
                this.$emit('remove-line-item', this.item.index);
            },
        },
        props: ['item', 'returnLabelText', 'displayPricing', 'displayReceived', 'displayItemReceived', 'displayReturning', 'returnQtyRequired'],
        watch: {
            item: {
                handler: function (after, before) {
                    this.updateLineItem();
                },
                deep: true
            },
        },
    }
</script>